// #standard page
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setActivePage } from "../../redux/appMenu/actions";
import PageTitle from '../../components/PageTitle';

//#table
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { currencyFormat } from '../../helpers/formatter';
import { noDataIndication } from '../../helpers/noDataIndication';

//#form
import {
    Row,
    Col,
    Card,
    CardBody,
    CustomInput,
    Nav,
    NavItem,
    NavLink,
    Alert
} from 'reactstrap';

//#other
import classnames from 'classnames';
import moment from 'moment';
import { fetchJSON } from '../../helpers/api';
import StatementOfAccount from './StatementOfAccount';

import InfoBanner from './InfoBanner';

class LeaseAccountSummary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            summaryData: [],
            statementData: [],
            transactionData: [],
            prepaidCashData: [],
            prepaidCreditData: [],
            fromDate: new Date(),
            toDate: new Date(),
            loadingSummary: true,
            loadingStatement: true,
            loadingTransactions: true,
            loadingPrepaidCash: true,
            loadingPrepaidCredit: true,
            view: 'Summary',
            summaryTabHeadings: [],
            statementTabHeadings: [],
            activeTab: '0',
        };
    }


    componentDidMount = () => {
        this.props.setActivePage();
        this.loadSummary();
        this.loadStatementOfAccount();
    };


    async loadSummary() {
        let url = `/portal/LeaseAccount/GetSummary`;
        let response = await fetchJSON(url);

        let lessees = [...new Set(response.data.map(({ partyName }) => partyName))];

        this.setState({
            summaryData: response.data,
            loadingSummary: response.loading,
            summaryTabHeadings: [...lessees]
        });
    }

    async loadStatementOfAccount() {
        let fromDate = moment(this.state.fromDate, moment.ISO_8601).format("DD-MMM-YYYY");
        let toDate = moment(this.state.toDate, moment.ISO_8601).format("DD-MMM-YYYY");
        let url = `/portal/LeaseAccount/GetStatementOfAccount?fromDate=${fromDate}&toDate=${toDate}`;
        let response = await fetchJSON(url);
        
        let lessees = [...new Set(response.data.totals.map(({ partyName }) => partyName))];        

        this.setState({
            statementData: response.data.totals,
            loadingStatement: response.loading,
            transactionData: response.data.transactions,
            loadingTransactions: response.loading,
            prepaidCashData: response.data.prepaidCash,
            loadingPrepaidCash: response.loading,
            prepaidCreditData: response.data.prepaidCredit,
            loadingPrepaidCredit: response.loading,
            statementTabHeadings: [...lessees],
        });
    }


    changeView = (e) => {
        let newView = e.currentTarget.value;
        
        this.setState({
            view: newView
        });
    }

    /**
    * Toggle the tab
    */
    toggle = (tab: string) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    };

    render() {

        const rowClasses = (row) => {            
            if (row.label) {
                if (row.label.toLowerCase().startsWith('total') || row.label.toLowerCase().startsWith('less')) {
                    return 'font-weight-bold';
                }
            }
        };


        const columns = [
            {
                dataField: 'label',
                text: '',
                classes: 'labelColumn',
            },
            {
                dataField: 'rental',
                text: 'Rental',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'supplementaryRent',
                text: 'Supplementary Rent',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'commitmentFee',
                text: 'Commitment Fee',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'latePaymentInterest',
                text: 'Late Payment Interest',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'other',
                text: 'Other',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
            {
                dataField: 'total',
                text: 'Total',
                headerClasses: 'numberColumn',
                classes: 'numberColumn',
                formatter: currencyFormat
            },
        ];

        const balanceAsOf = () => {
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            let todayString = moment(today, moment.ISO_8601).format("ddd MMM DD YYYY HH:mm:ss") + " Irish Time";
            //Balance as of Fri Apr 23 2021 00:00:00 Irish Time
            return todayString;
        }

        return (
            <React.Fragment>
                <PageTitle
                    breadCrumbItems={[
                        { label: 'Lease Account Summary', path: '/LeaseAccountSummary', active: true },
                    ]}
                    title={'Lease Account Summary'}
                />

                <InfoBanner />
                
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <CustomInput type="radio" id="viewFilter_01" name="viewFilter" label="Summary" value="Summary" defaultChecked={this.state.view === "Summary"} onClick={this.changeView} inline className="linkCursor" />{'  '}
                                <CustomInput type="radio" id="viewFilter_02" name="viewFilter" label="Statement Of Account" value="Statement" defaultChecked={this.state.view === "Statement"} onClick={this.changeView} inline className="linkCursor" />{'  '}
                            </Col>
                        </Row>
                        <br />
                        <React.Fragment>
                            {this.state.view === "Summary" && this.state.summaryTabHeadings.length <= 1 && (
                                <React.Fragment>
                                    <ToolkitProvider
                                        bootstrap4
                                        keyField="keyField"
                                        data={this.state.summaryData}
                                        columns={columns}
                                    >
                                        {props => (
                                            <React.Fragment>
                                                <BootstrapTable
                                                    {...props.baseProps}
                                                    bordered={false}
                                                    noDataIndication={noDataIndication(this.state.loadingSummary)}
                                                    hover
                                                    wrapperClasses="table-responsive"
                                                    rowClasses={rowClasses}
                                                />
                                            </React.Fragment>
                                        )}
                                    </ToolkitProvider>
                                    <span className="float-right"><small><em>Balance as of {balanceAsOf()}</em></small></span>

                                </React.Fragment>
                            )}

                            {/* Multiple parties */}
                            {this.state.view === "Summary" && this.state.summaryTabHeadings.length > 1 && (
                                <React.Fragment>
                                    <Nav tabs className="nav-bordered">
                                        {this.state.summaryTabHeadings.map((tab, index) => {
                                            return (
                                                <NavItem key={index}>
                                                    <NavLink
                                                        href="#"
                                                        className={classnames({ active: this.state.activeTab === index.toString() }, { 'bg-light-lighten': index === 0 })}
                                                        onClick={() => {
                                                            this.toggle(index.toString());
                                                        }}>
                                                        <span>{tab}</span>
                                                    </NavLink>
                                                </NavItem>
                                            );
                                        })}
                                    </Nav>

                                    <br />
                                    <ToolkitProvider
                                        bootstrap4
                                        keyField="keyField"
                                        data={this.state.summaryData.filter(l => l.partyName === this.state.summaryTabHeadings[this.state.activeTab])}
                                        columns={columns}
                                    >
                                        {props => (
                                            <React.Fragment>
                                                <BootstrapTable
                                                    {...props.baseProps}
                                                    bordered={false}
                                                    noDataIndication={noDataIndication(this.state.loadingSummary)}
                                                    hover
                                                    wrapperClasses="table-responsive"
                                                    rowClasses={rowClasses}
                                                />
                                            </React.Fragment>
                                        )}
                                    </ToolkitProvider>
                                    <span className="float-right"><small><em>Balance as of {balanceAsOf()}</em></small></span>

                                </React.Fragment>
                            )}

                            {this.state.view === "Statement" && (
                                <StatementOfAccount
                                    data={this.state.statementData}
                                    transactionData={this.state.transactionData}
                                    prepaidCashData={this.state.prepaidCashData}
                                    prepaidCreditData={this.state.prepaidCreditData}
                                    fromDate={this.state.fromDate}
                                    toDate={this.state.toDate}
                                    loading={this.state.loadingStatement}
                                    loadingTransactions={this.state.loadingTransactions}
                                    loadingPrepaidCash={this.state.loadingPrepaidCash}
                                    loadingPrepaidCredit={this.state.loadingPrepaidCredit}
                                    tabHeadings={this.state.statementTabHeadings}
                                />
                            )}
                        </React.Fragment>

                    </CardBody>
                </Card>

            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setActivePage: () => {
            dispatch(setActivePage("LeaseAccount_Summary"));
        }
    };
}
export default connect(null, mapDispatchToProps)(LeaseAccountSummary);